module.exports = "/packs/change-summary-sp-56f74769f7f08c9720140f94a8fc44c2.png";